// extracted by mini-css-extract-plugin
export default {"menu":"Menu-module--menu--MzSVZ","open":"Menu-module--open--f7XIl","link":"Menu-module--link--pAipe","linkActive":"Menu-module--linkActive--GLqun"};